import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import { inject, observer } from "mobx-react";
import dayjs from "dayjs";
import { c } from "../../theme/colorUtils";
import TitleBox from "../CommonComponent/TitleBox";
import CommonLoading from "@/views/CommonComponent/CommonLoading";
import { DeviceCard, DeviceIconWrap, DeviceInfo } from "./Styled/ConnectedPokoroListStyled";
import EmptyImage from "@/common/Images/Detective.png";
import DeviceImage from "@/common/Images/PokoroPen.png";
import {DATE_UTIL} from "../../common/util/date.util";
import { useToast } from "@/components/useToast";

const PendingDeviceDisconnectToastKey = "_PENDING_DEVICE_DISCONNECT_TOAST_";

function ConnectedPokoroList(props) {
  const { intl, authStore, userStore } = props;
  const history = useHistory();
  const { showDeleteToast } = useToast();

  useEffect(() => {
    if (authStore.loginUser?.id) {
      userStore.getUserDeviceList(authStore.loginUser.id, false);
    }
  }, [authStore.loginUser?.id]);

  useEffect(() => {
    const shouldShow = localStorage.getItem(PendingDeviceDisconnectToastKey) === "true";
    if (!shouldShow) {
      return;
    }
    localStorage.removeItem(PendingDeviceDisconnectToastKey);
    showDeleteToast(intl.formatMessage({ id: "device_disconnect_success_toast" }));
  }, [intl, showDeleteToast]);

  const handleBack = () => {
    history.push("/setting");
  };

  const getDeviceDisplayName = (deviceName) => {
    return (deviceName || "").trim();
  };

  const isLoading = userStore.isUserDeviceListLoading;
  const deviceList = userStore.userDeviceList;

  return (
    <>
      <Stack width="100%">
        <TitleBox
          title={intl.formatMessage({ id: "setting_connected_pokoro_list" })} /* 연결된 포코로 목록 */
          subtitle={intl.formatMessage({ id: "setting_connected_list_description" })} /* 계정과 연결된 포코로 펜을 확인하고 관리할 수 있어요. */
          onBack={handleBack}
        />
        <Stack pt={4} px={2}>
          {isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
              <CommonLoading />
            </Box>
          ) : deviceList.length === 0 ? (
            <Stack alignItems="center" justifyContent="center" py={6} spacing={1}>
              <img src={EmptyImage} alt="Empty" width={64} />
              <Typography variant="body2">
                {intl.formatMessage({ id: "none_connect" })} {/* 연결된 포코로가 없습니다. */}
              </Typography>
            </Stack>
          ) : (
            <Stack spacing={1}>
              {deviceList.map((device) => (
                <DeviceCard
                  key={device.deviceId}
                  onClick={() => history.push("/deviceDetail", { deviceId: device.deviceId })}
                  sx={{ cursor: "pointer" }}
                >
                  <DeviceIconWrap>
                    <img src={DeviceImage} alt="Device" width={48} />
                  </DeviceIconWrap>
                  <DeviceInfo>
                    <Typography variant="body1" noWrap>
                      {getDeviceDisplayName(device.deviceName)}
                    </Typography>
                    <Typography variant="caption" color={c.text02}>
                      {intl.formatMessage({ id: "device_last_connection_date" })} :{" "}
                      {device.lastUsedDatetime ? DATE_UTIL.convertUTCToTimeZone(device.lastUsedDatetime, 'YYYY. MM. DD') : '—'}
                    </Typography>
                  </DeviceInfo>
                </DeviceCard>
              ))}
            </Stack>
          )}
        </Stack>
      </Stack>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CommonLoading />
        </div>
      )}
    </>
  );
}

export default injectIntl(inject("authStore", "userStore")(observer(ConnectedPokoroList)));
